module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-wedding2-f1dbb859e20f58a72feae141d64ef4a2.jpg";